import React from 'react';
import dynamic from 'next/dynamic';

const MobilePhoneNumberWidget = dynamic(() =>
  import('../MobilePhoneNumberWidget').then((mod) => ({
    default: mod.MobilePhoneNumberWidget
  }))
);
const GetStartedNoPhoneWidget = dynamic(() =>
  import('../GetStartedNoPhoneWidget').then((mod) => ({
    default: mod.GetStartedNoPhoneWidget
  }))
);
const GetStartedWidget = dynamic(() =>
  import('../GetStartedWidget').then((mod) => ({
    default: mod.GetStartedWidget
  }))
);
const RoleSelectWebregWidget = dynamic(() =>
  import('../RoleSelectWidgetWebreg').then((mod) => ({
    default: mod.RoleSelectWebregWidget
  }))
);
const LoaderStickyButton = dynamic(() =>
  import('../LoaderStickyButton').then((mod) => ({
    default: mod.LoaderStickyButton
  }))
);
const StandardWidget = dynamic(() =>
  import('../StandardWidget').then((mod) => ({ default: mod.StandardWidget }))
);

const EmailWidget = dynamic(() =>
  import('../EmailWidget').then((mod) => ({ default: mod.EmailWidget }))
);
const CognitoAuthWidget = dynamic(() =>
  import('../CognitoAuthWidget').then((mod) => ({
    default: mod.CognitoAuthWidget
  }))
);
const InlineAuthWidget = dynamic(() =>
  import('../InlineAuthWidget').then((mod) => ({
    default: mod.InlineAuthWidget
  }))
);

import { GetStartedWidgetProps } from '../GetStartedWidget';
import { WidgetProps, ctaWidgetEnum, SharedProps } from '../shared';

type CtaWidgetProps = GetStartedWidgetProps | (WidgetProps & SharedProps);

export function CtaWidgetMap({
  designType,
  ...props
}: CtaWidgetProps & { designType: ctaWidgetEnum }) {
  switch (designType) {
    case ctaWidgetEnum.SMS_REG:
      return (
        <MobilePhoneNumberWidget
          {...(props as WidgetProps)}
          showErrorBanner={false}
          returningUserButtonText={undefined}
        />
      );

    case ctaWidgetEnum.MOBILE_PHONE_NUMBER:
      return <MobilePhoneNumberWidget {...(props as WidgetProps)} />;

    case ctaWidgetEnum.MOBILE_PHONE_NUMBER_DROPSHADOW:
      return (
        <MobilePhoneNumberWidget
          {...(props as WidgetProps)}
          useDropshadow={true}
        />
      );

    case ctaWidgetEnum.GET_STARTED_NO_PHONE:
      return <GetStartedNoPhoneWidget {...props} />;

    case ctaWidgetEnum.EMAIL:
      return <EmailWidget {...props} />;

    case ctaWidgetEnum.GET_STARTED:
      return <GetStartedWidget {...(props as GetStartedWidgetProps)} />;

    case ctaWidgetEnum.LOADER_STICKY_BUTTON:
      return <LoaderStickyButton {...(props as WidgetProps)} />;

    case ctaWidgetEnum.STANDARD:
      return <StandardWidget {...props} />;

    case ctaWidgetEnum.DUAL_CTA_BUTTON:
    case ctaWidgetEnum.ROLE_SELECT_WEBREG:
      return (
        <RoleSelectWebregWidget
          {...(props as WidgetProps)}
          designType={designType}
        />
      );

    case ctaWidgetEnum.GL4C_AUTH:
      return <CognitoAuthWidget {...props} />;

    case ctaWidgetEnum.GL4C_INLINE_AUTH:
      return <InlineAuthWidget {...props} />;

    default:
      return null;
  }
}
